import newsData from "./newsData";

const News = () => {
  return (
    <div className="project-container">
      <h2>News</h2>
      <ul>
        {newsData.map((awards, index) => (
          <li key={index}>
            [{awards.date}] <span dangerouslySetInnerHTML={{ __html: awards.content }} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default News;